import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ActivityCard from "./ActivitiesCards";
import Particle from "../Particle";
import sen_citizen from "../../Assets/Projects/senior_citizens.jpg";
import code_soil from "../../Assets/Projects/code-soil.jpg";
import workshop from "../../Assets/Projects/workshop.jpg";
import syep2 from "../../Assets/Projects/syep.png";
import syep from "../../Assets/Projects/syep-2024.jpg";
import urban_alchemy from "../../Assets/Projects/urban.jpg";



function Activity() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Community <strong className="purple">Impact</strong>
        </h1>
        <p style={{ color: "white" }}>
        Empowering youth, underserved communities, and seniors with essential technology skills, fostering self-sufficiency, creativity, and social contribution for a sustainable future.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ActivityCard
              imgPath={syep}
              isBlog={false}
              title="Summer Youth Employment Program-2024"
              text=" Hands-On Skills and Industry Experience "
              description="This training was aimed at guiding young individuals from diverse backgrounds to become professionals who not only lead self-sufficient, safe, and healthy lives but also actively contribute to the growth and sustainability of their communities."
               text1=""
              ghLink="/syep-2024"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ActivityCard
              imgPath={workshop}
              isBlog={false}
              title="Tech Innovation Workshops"
              text="Hands-On Workshops"
              description="These hands-on workshop series are designed to inspire and equip youth and young adults with the skills needed to excel in the fast-paced fields of software development, electronics, and robotics. "
              text1=""
              ghLink="/workshops"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ActivityCard
              imgPath={urban_alchemy }
              isBlog={false}
              title="Equipping Sheltered Individuals with Computer Literacy"
              text="Computer Skills Training "
              description="This program aims to equip homeless shelter residents with essential computer skills, enabling them to navigate modern job markets and access educational resources. "
              text1=""
              ghLink="/shelters"
              demoLink="#"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ActivityCard
              imgPath={syep2}
              isBlog={false}
              title="Summer Youth Employment Program-2025"
              text="Hands-On Skills and Industry Experience"
              description="This training will be aimed at guiding young individuals from diverse backgrounds to become professionals who not only lead self-sufficient, safe, and healthy lives but also actively contribute to the growth and sustainability of their communities."
              text1=""
              ghLink=""
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ActivityCard
              imgPath={sen_citizen}
              isBlog={false}
              title="Empowering Seniors with Technology"
              text="Digital Literacy Programs"
              description="This program is designed for senior citizens by providing hands-on training in basic technology use, including smartphones, computers, and internet navigation. Participants learn about security issues, access online services, and explore educational resources. "
              text1=""
              ghLink="/seniors"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ActivityCard
              imgPath={code_soil}
              isBlog={false}
              title="Social Action in the Neighborhood"
              text="Code and Soil"
              description="Code & Soil is a unique program that combines the power of technology and nature to engage children and youth in both gardening and coding. participants learn the basics of coding while also gaining hands-on experience in sustainable organic gardening practices. "
              text1=""
              ghLink="/neighbors"
              demoLink="#"
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Activity;
